import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe, faTrashAlt, faSyncAlt, faToggleOn, faToggleOff } from "@fortawesome/free-solid-svg-icons";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import axiosInstance from "../../interceptor/axiosInstance";
import NotificationService from '../Utils/NotificationService.js';
import { formatTime } from '../Utils/UtilityService.js';
import { useScan } from './TabsKnowledgeCentre';

const ScanWebsite = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [websiteRescanPopup, setWebsiteRescanPopup] = useState(false);
  const [websiteURL, setWebsiteURL] = useState(null);
  const [isInvalidURL, setIsInvalidURL] = useState(false);
  const [isURLAccessible, setIsURLAccessible] = useState(true);
  const [webPageList, setWebPageList] = useState([]);
  const [subWebPageList, setSubWebPageList] = useState([]);
  const [expandedRow, setExpandedRow] = useState(null);
  const [maxScanUrl, setMaxScanUrl] = useState(null);
  const [totalSubUrls, setTotalSubUrls] = useState(0);
  const [isScanDisabled, setIsScanDisabled] = useState(true);
  const [showConfirmExclude, setShowConfirmExclude] = useState(false);
  const [showConfirmInclude, setShowConfirmInclude] = useState(false);
  const [showConfirmRescan, setShowConfirmRescan] = useState(false);
  const [pageToExclude, setPageToExclude] = useState(null);
  const [pageToInclude, setPageToInclude] = useState(null);
  const [pageToRescan, setPageToRescan] = useState(null);

  const [toggleStates, setToggleStates] = useState({});
  const [showPagePopup, setShowPagePopup] = useState(false);
  const [isEmptyUrl, setIsEmptyUrl] = useState(false);
  const {isUrlScanning, setIsUrlScanning} = useScan();

  const urlPattern = /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?(\/[a-zA-Z0-9._-]+)*\/?$/;
  
  useEffect(() => {
    getAccess();
    fetchOrgScannedWebsite();
  }, []);

  const handleScanClick = () => {
    setIsInvalidURL(false);
    setIsURLAccessible(true);
    if(webPageList && webPageList.length > 0 && webPageList[0].subURL && webPageList[0].subURL.length) {
      setWebsiteURL(webPageList[0].url)
      setWebsiteRescanPopup(true)
    } else {
      setShowPopup(true);
    }
  };

  // const handleReScanWebsite = () => {
  //   setShowPopup(true);
  // }

  const handleScanPageClick = () => {
    // setIsInvalidURL(false);
    setIsInvalidURL(false);
    setIsURLAccessible(true);
    setShowPagePopup(true);
  };

  const handleToggle = (page, subUrlId, isActive) => {
    setToggleStates((prevState) => ({
      ...prevState,
      [subUrlId]: !(prevState[subUrlId] ?? isActive), // Toggle using page.is_active as fallback
    }));
    if (isActive) {
      confirmExclude(page);
    } else {
      confirmInclude(page);
    }
  };

  const handleRescanPage = (page) => {
    setPageToRescan(page);
    setShowConfirmRescan(true);
  };

  const isUrlAccessible = async (websiteURL) => {
    try {
      new URL(websiteURL);
      console.log("inn")
      const response = await fetch(websiteURL, { method: "GET", mode: "cors" }); // Only checks if the URL exists
      const data = await response.text(); 

      console.log("res => ", data.slice(0, 200))
      // console.log("validate")
      // return { isValid: true, isAccessible: response.ok };
    } catch (error) {
      console.log("error: ", error)
      console.log("invalid")
      // return { isValid: true, isAccessible: false };
    }
  }

  const validateURL = async (inputUrl) => {
    try {
      const urlObj = new URL(inputUrl);
      // setCurrentUrl(urlObj.href);
      const currentUrl = window.location.href;
      console.log("current url : ", currentUrl)
      const response = await fetch(inputUrl, { method: "HEAD", redirect: "manual" });
      // setIsRedirected(response.url !== inputUrl);
      console.log("pp: ", (response.url !== inputUrl))
      return true;
    } catch (_) {
      // setCurrentUrl("");
      // setIsRedirected(null);
      return false;
    }
  };

  const isValidURL = (url) => {
    try {
      new URL(url);
      return true;
    } catch (error) {
      return false;
    }
  };

  // Function to check if the URL is accessible
  const checkURLAccessibility = async () => {
    
    try {
      const response = await axiosInstance.get(`org/check-url`, { params: { url: websiteURL }, });
      if (response.data.accessible) {
        setIsURLAccessible(true);
      } else {
        setIsURLAccessible(false);
      }
      return response.data.accessible;
    } catch (error) {
      setIsURLAccessible(false);
    }
  };

  const onClickScanWebsite = async () => {
    if (!websiteURL.trim() || !urlPattern.test(websiteURL.trim())) {
      setIsInvalidURL(true);
      // return;
    }
    
    const isAccessible = await checkURLAccessibility();
    if (!isAccessible) {
      NotificationService.error("URL is not accessible.");
      return;
    }

    try {
      const res = await axiosInstance.get(`org/scan-url?url=${websiteURL.trim()}`);
      setShowPopup(false);
      setWebsiteRescanPopup(false);
      // fetchOrgScannedWebsite();
      if(res.data.success) {
        setIsUrlScanning(true);
        NotificationService.success(res.data.message);
      } else {
        NotificationService.error(res.data.message);
      }
    } catch (err) {
      NotificationService.error('Error to scanned website.');
    }
  }

  const onClickScanWebPage = async () => {
    if (!websiteURL.trim() || !urlPattern.test(websiteURL.trim())) {
      setIsInvalidURL(true);
      // return;
    }

    const isAccessible = await checkURLAccessibility();
    if (!isAccessible) {
      NotificationService.error("URL is not accessible.");
      return;
    }

    try {
      const res = await axiosInstance.get(`org/scan-webpage?url=${websiteURL.trim()}`);
      setShowPagePopup(false);
      fetchOrgScannedWebsite();
      if(res.data.success) {        
        NotificationService.success(res.data.message);
      } else {
        NotificationService.error(res.data.message);
      }
    } catch (err) {
      NotificationService.error('Error to scanned website.');
    }
  }

  // Fetch the list of web pages
  const fetchOrgScannedWebsite = async () => {
    try {
      const response = await axiosInstance.get(`/org/get-scanned-pages`);
      setWebPageList(response.data.length > 0 ? [response.data[0]] : []); 
      setIsUrlScanning(response.data.length > 0 ? (response.data[0].is_scanning === null ? false : true) : false)
      const totalSubUrls = response.data.reduce((sum, item) => sum + (parseInt(item.total_active_sub_url, 10) || 0), 0);
      setTotalSubUrls(totalSubUrls);
    } catch (error) {
      console.error('Error fetching scanned pages:', error);
    }
  };

  const toggleRow = async (id) => {
    setExpandedRow(expandedRow === id ? null : id);
    try {
      const response = await axiosInstance.get(`/org/get-scanned-sub-pages?urlId=${id}`);
      setSubWebPageList(response.data);
    } catch (error) {
      console.error('Error fetching scanned pages:', error);
    }
  };

  const getAccess = async () => {
    try {
      const response = await axiosInstance.get(`/org/check-access`);
      const maxUrlScanSetting = response.data.find(
        (setting) => setting.setting_key === "max_url_scan"
      );
      if (maxUrlScanSetting) {
        setMaxScanUrl(parseInt(maxUrlScanSetting.setting_value, 10));
      }
    } catch (err) {
      console.error("Error fetching access settings", err);
    }
  };

  useEffect(() => {
    if (maxScanUrl !== null) {
      setIsScanDisabled(totalSubUrls >= maxScanUrl);
    }
  }, [totalSubUrls, maxScanUrl]);

  useEffect(() => {
    if (maxScanUrl !== null) {
      setIsScanDisabled(totalSubUrls >= maxScanUrl);
    }
    if(webPageList && webPageList.length>0) {
      setIsEmptyUrl(false);
    }
    else {
      setIsEmptyUrl(true);
    }
  }, [webPageList]);

  const confirmExclude = (page) => {
    setPageToExclude(page);
    setShowConfirmExclude(true);
  };

  const confirmInclude = (page) => {
    setPageToInclude(page);
    setShowConfirmInclude(true);
  };

  const cancelExclude = () => {
    if (pageToExclude) {
      const subUrlId = pageToExclude.sub_url_id;
  
      // Revert toggle state on cancel
      setToggleStates((prevState) => ({
        ...prevState,
        [subUrlId]: true, 
      }));
    }

    setShowConfirmExclude(false);
    setPageToExclude(null);
  };

  const cancelInclude = () => {
    if (pageToInclude) {
      const subUrlId = pageToInclude.sub_url_id;
  
      // Revert toggle state on cancel
      setToggleStates((prevState) => ({
        ...prevState,
        [subUrlId]: false, 
      }));
    }

    setShowConfirmInclude(false);
    setPageToInclude(null);
  };

  const cancelRescan = () => {
    setShowConfirmRescan(false);
    setPageToRescan(null);
  };

  const handleExclude = async () => {
    if (pageToExclude) {
      const payload = { subUrlId: pageToExclude.sub_url_id };
      try {
        const res = await axiosInstance.post(`/org/exclude-url`, payload);
        NotificationService.success(res.data.message);
        fetchOrgScannedWebsite();
        toggleRow(pageToExclude.url_id);
        setShowConfirmExclude(false);
        setPageToExclude(null);
      } catch (error) {
        console.error(`Error excluding the file`, error);
      }
    }
  };

  const handleInclude = async () => {
    if (pageToInclude) {
      const payload = { subUrlId: pageToInclude.sub_url_id };
      try {
        const res = await axiosInstance.post(`/org/include-url`, payload);
        NotificationService.success(res.data.message);
        fetchOrgScannedWebsite();
        toggleRow(pageToInclude.url_id);
        setShowConfirmInclude(false);
        setPageToInclude(null);
      } catch (error) {
        console.error(`Error to including the file`, error);
      }
    }
  };

  const handleRescan = async () => {
    if (pageToRescan) {
      const payload = { subUrlId: pageToRescan.sub_url_id, url: pageToRescan.url };
      try {
        const res = await axiosInstance.post(`/org/rescan-url`, payload);
        console.log(`Url rescan successfully`);
        if (res.data.success) {
          NotificationService.success(res.data.message);
        } else {
          NotificationService.error(res.data.message);
        }
        fetchOrgScannedWebsite();
        setShowConfirmRescan(false);  // Close confirmation after deletion
        setPageToRescan(null);  // Clear the file to delete
      } catch (error) {
        console.error(`Error rescan url`, error);
      }
    }
  };

  const handleKeyDownWebPage = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onClickScanWebPage();
    }
  };

  const handleKeyDownWebSite = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onClickScanWebsite();
    }
  };

  return (
    <div>
      <div className="agent-container hero-section text-center mb-4 p-4" style={styles.heroSection}>
        <h2 className="heading-large">Train Your Assistant with Website Data</h2>
        <p className="conv-content">
          Scan websites to train the assistant with relevant information. Your assistant will analyze the website content and provide responses based on the extracted data.
        </p>
        <button
          className={isUrlScanning? "btn btn-secondary-color" : "btn btn-color"}
          onClick={handleScanClick}
          disabled={isUrlScanning}
        >
          <FontAwesomeIcon icon={faGlobe} size="lg" /> Scan Website
        </button>
        {isScanDisabled && (
          <div> <span style={{ color: "red", marginRight: "10px" }} className='conv-content'>
            Your organization has reached the URL scan limit. You can only scan {maxScanUrl} URLs and sub URLs. To continue scanning more websites, please upgrade your plan or contact support for assistance.
          </span>
          </div>
        )}

        {isUrlScanning && (
          <div className="scan-container mt-3">
            <div className="loader"></div>
            <span className="scan-text">
              Website Scanning in progress.{" "}
              <span className="click-here"
              onClick={fetchOrgScannedWebsite}
              >
                Click here
              </span>{" "}
              to refresh the screen to see already scanned pages.
            </span>
          </div>
        )}
        
      </div>

      {showPopup && (
        <div style={styles.popup}>
          <div style={styles.popupContent}>
            {/* Close Button */}
            <div style={{ textAlign: 'end' }}>
              <button
                style={styles.closeButton}
                onClick={() => {
                  setWebsiteURL("");
                  setIsInvalidURL(false);
                  setShowPopup(false);
                  setIsURLAccessible(true);
                }}
                aria-label="Close"
              >
                &times;
              </button>
            </div>

            {/* Heading */}
            <h3 className="heading-large">Scan Website</h3>
            <p className="conv-content">Enter the website URL to extract relevant information for training your assistant.</p>

            {/* Input Field for Website URL */}
            <input
              type="text"
              placeholder="Enter website URL (e.g., https://example.com)"
              value={websiteURL}
              onChange={(e) => setWebsiteURL(e.target.value)}
              onKeyDown={handleKeyDownWebSite}
              style={styles.inputField}
              className="mb-2"
            />

            {/* Validation Message */}
            {/* {isInvalidURL && (
              <div style={styles.validationMessage}>
                Please enter a valid website URL (e.g., https://example.com).
              </div>
            )} */}

            {/* Validation Message for url accessible or not */}
            {!isURLAccessible && (
              <div style={styles.validationMessage}>
                The given URL is either not accessible or is redirecting to a different URL.
              </div>
            )}

            {/* Guidelines */}
            <p className="details-font-value mt-3">
              <ul>
                <li>Ensure the website allows public data extraction.</li>
                <li>Some dynamic content may not be fully accessible.</li>
                <li>Scanning may take a few seconds, depending on the website.</li>
              </ul>
            </p>

            {/* Scan Button */}
            <div style={{ textAlign: "end" }}>
              <button
                className="btn btn-primary"
                onClick={onClickScanWebsite}
                style={styles.scanButton}
              >
                Scan Website
              </button>
            </div>
          </div>
        </div>
      )}

      {websiteRescanPopup && (
        <div style={styles.popup}>
          <div style={styles.popupContent}>
            {/* Close Button */}
            <div style={{ textAlign: "end" }}>
              <button
                style={styles.closeButton}
                onClick={() => {
                  setWebsiteURL("");
                  setIsInvalidURL(false);
                  setWebsiteRescanPopup(false);
                  setIsURLAccessible(true)
                }}
                aria-label="Close"
              >
                &times;
              </button>
            </div>
        
            {/* Confirmation Message */}
            <p>
              <strong>Are you sure you want to rescan a website for the Knowledge Base?</strong>
            </p>
            <p style={{ color: "red" }}>
              Rescanning a website will <strong>delete all previously scanned data</strong>. This action cannot be undone.
            </p>
        
            {/* Instruction */}
            <p className="conv-content">
              Enter the website URL to extract relevant information for training your assistant.
            </p>
        
            {/* Input Field for Website URL */}
            <input
              type="text"
              placeholder="Enter website URL (e.g., https://example.com)"
              value={websiteURL}
              onChange={(e) => setWebsiteURL(e.target.value)}
              onKeyDown={handleKeyDownWebSite}
              style={styles.inputField}
              className="mb-2"
            />
        
            {/* Validation Message */}
            {/* {isInvalidURL && (
              <div style={styles.validationMessage}>
                Please enter a valid website URL (e.g., https://example.com).
              </div>
            )} */}
        
            {/* Validation Message for url accessible or not */}
            {!isURLAccessible && (
              <div style={styles.validationMessage}>
                The given URL is either not accessible or is redirecting to a different URL.
              </div>
            )}

            {/* Guidelines */}
            <ul className="details-font-value mt-3">
              <li>Ensure the website allows public data extraction.</li>
              <li>Some dynamic content may not be fully accessible.</li>
              <li>Scanning may take a few seconds, depending on the website.</li>
            </ul>
        
            {/* Confirmation Buttons */}
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px", gap: "10px" }}>
              <button
                className="btn btn-success"
                onClick={onClickScanWebsite} // Proceed with rescanning
                style={styles.scanButton}
              >
                Yes, Rescan
              </button>
        
              <button
                className="btn btn-secondary"
                onClick={() => setWebsiteRescanPopup(false)} // Close popup
                style={styles.cancelButton}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>      
      )}

      {showPagePopup && (
        <div style={styles.popup}>
          <div style={styles.popupContent}>
            {/* Close Button */}
            <div style={{ textAlign: 'end' }}>
              <button
                style={styles.closeButton}
                onClick={() => {
                  setWebsiteURL("");
                  setIsInvalidURL(false);
                  setShowPagePopup(false);
                  setIsURLAccessible(true)
                }}
                aria-label="Close"
              >
                &times;
              </button>
            </div>

            {/* Heading */}
            <h3 className="heading-large">Scan Web Page</h3>
            <p className="conv-content">
              Enter the URL of the web page you want to scan. The system will extract relevant information to enhance your assistant’s training data.
            </p>

            {/* Input Field for Website URL */}
            <input
              type="text"
              placeholder="Enter website URL (e.g., https://example.com)"
              value={websiteURL}
              onChange={(e) => setWebsiteURL(e.target.value)}
              onKeyDown={handleKeyDownWebPage}
              style={styles.inputField}
              className="mb-2"
            />

            {/* Validation Message */}
            {/* {isInvalidURL && (
              <div style={styles.validationMessage}>
                Please enter a valid website URL (e.g., https://example.com).
              </div>
            )} */}

            {/* Validation Message for url accessible or not */}
            {!isURLAccessible && (
              <div style={styles.validationMessage}>
                The given URL is either not accessible or is redirecting to a different URL.
              </div>
            )}

            {/* Guidelines */}
            <p className="details-font-value mt-3">
              <strong>Before Scanning, Please Note:</strong>
              <ul>
                <li>The web page must be publicly accessible.</li>
                <li>Scanning works best for static content (text, articles, etc.).</li>
                <li>Dynamic or interactive content (e.g., login-protected pages) may not be fully extracted.</li>
                <li>Depending on the page size, scanning may take a few seconds.</li>
              </ul>
            </p>

            {/* Scan Button */}
            <div style={{ textAlign: "end" }}>
              <button
                className="btn btn-primary"
                onClick={onClickScanWebPage}
                style={styles.scanButton}
              >
                Add Web Page
              </button>
            </div>
          </div>
        </div>
      )}

      {showConfirmExclude && (
        <div style={styles.popup}>
          <div style={styles.deletePopupContent}>
            <h3 style={styles.popupTitle}>Exclude URL from Knowledge Base</h3>
            <p style={styles.popupDescription}>
              Are you sure you want to exclude the URL <strong>{pageToExclude?.url}</strong> from the Knowledge Base?<br/>  
              This action will prevent the assistant from using its content in responses.
            </p>
            <div style={{ textAlign: 'end' }}>
              <button
                className="btn btn-warning"
                onClick={handleExclude}
                style={styles.deleteButton}
              >
                Yes, Exclude
              </button>
              <button
                className="btn btn-secondary"
                onClick={cancelExclude}
                style={styles.cancelButton}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {showConfirmInclude && (
        <div style={styles.popup}>
          <div style={styles.deletePopupContent}>
            <h3 style={styles.popupTitle}>Include URL in Knowledge Base</h3>
            <p style={styles.popupDescription}>
              Are you sure you want to include the URL <strong>{pageToInclude?.url}</strong> in the Knowledge Base?  
              <br />This action will allow the assistant to use its content in responses.
            </p>
            <div style={{ textAlign: 'end' }}>
              <button
                className="btn btn-success"
                onClick={handleInclude}
                style={styles.deleteButton}
              >
                Yes, Include
              </button>
              <button
                className="btn btn-secondary"
                onClick={cancelInclude}
                style={styles.cancelButton}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {showConfirmRescan && (
        <div style={styles.popup}>
          <div style={styles.rescanPopupContent}>
            <h3 style={styles.popupTitle}>Confirm Rescan</h3>
            <p style={styles.popupDescription}>
              Are you sure you want to rescan the URL <strong>{pageToRescan?.url}</strong>?
            </p>
            <div style={{ textAlign: 'end' }}>
              <button
                className="btn btn-success"
                onClick={handleRescan}
                style={styles.rescanButton}
              >
                Yes, Rescan
              </button>
              <button
                className="btn btn-secondary"
                onClick={cancelRescan}
                style={styles.cancelButton}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>      
      )}

      <div className="agent-container">
        <div>
          {webPageList && webPageList.length > 0 && webPageList[0].subURL && webPageList[0].subURL.length > 0 && (
            webPageList.map((page, index) => (
              <div key={index} className="row mb-2">
                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <strong>Url: </strong>
                  <a href={page.url} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    {page.url}
                  </a>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <div className="button-container">
                    <strong>Total Sub URLs:&nbsp;</strong> {page?.total_active_sub_url ?? 0} / {maxScanUrl ?? 0}
                  </div>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <strong>Date:</strong> {page.created_at ? formatTime(page.created_at) : ""}
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <div className="button-container">
                    <button
                      className={isScanDisabled || isEmptyUrl || isUrlScanning ? "btn btn-secondary-color" : "btn btn-color"}
                      onClick={handleScanPageClick}
                      disabled={isScanDisabled || isEmptyUrl || isUrlScanning}
                    >
                      <FontAwesomeIcon icon={faGlobe} size="lg" /> Add Web Page
                    </button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
    
        <div style={{ maxHeight: "400px", overflowY: "auto", border: "1px solid #ddd" }} className="table-container">
          <table style={{ width: "100%", borderCollapse: "collapse" }}>            
            <tbody>
              {webPageList && webPageList.length > 0 && webPageList[0].subURL && webPageList[0].subURL.length > 0 ? (
                webPageList.map((page, index) => (
                  <React.Fragment key={page.url_id}>
                    <tr>
                      <td colSpan="5" style={styles.subRow}>
                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                          <thead
                            style={{
                              position: "static",
                              top: "0",
                              background: "#fff",
                              zIndex: "10",
                              boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)"
                            }}
                          >
                            <tr className="tbl-header-color conv-user">
                              <th style={{ ...styles.headerCell, width: "25px" }} colSpan="4">No.</th>
                              <th style={styles.headerCell} colSpan="4">Url</th>
                              <th style={styles.headerCell} colSpan="4">Date</th>
                              <th style={{ ...styles.headerCell, width: "25px" }} colSpan="4">Action</th>
                            </tr>
                          </thead>

                          <tbody>
                            {page.subURL && page.subURL.length > 0 ? (
                              page.subURL.map((page, index) => (
                                <tr
                                  key={page.id}
                                  style={styles.row}
                                  className={`conv-content`}
                                >
                                  <td style={styles.cell} colSpan="4">{index + 1}</td>
                                  <td style={styles.cell} colSpan="4">
                                    <a href={page.url} target="_blank" rel="noopener noreferrer">
                                      {page.url}
                                    </a>
                                  </td>
                                  <td style={styles.cell} colSpan="4">{formatTime(page.created_at)}</td>
                                  <td style={styles.cell} colSpan="4">
                                    {!isUrlScanning && (
                                      <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                                      <FontAwesomeIcon
                                        icon={(toggleStates[page.sub_url_id] ?? page.is_active) ? faToggleOn : faToggleOff}
                                        style={{
                                          cursor: "pointer",
                                          color: (toggleStates[page.sub_url_id] ?? page.is_active) ? "#28a745" : "#ff0000", // Green when ON, Red when OFF
                                          fontSize: "25px",
                                        }}
                                        onClick={() => handleToggle(page, page.sub_url_id, page.is_active)}
                                        title={(toggleStates[page.sub_url_id] ?? page.is_active) ? "Exclude from KB" : "Include in KB"}
                                      />

                                      <FontAwesomeIcon
                                        icon={faSyncAlt}
                                        style={{
                                          cursor: page.is_active ? "pointer" : "not-allowed",
                                          color: page.is_active ? "#007bff" : "#a0a0a0", // Blue when enabled, Gray when disabled
                                          fontSize: "20px",
                                          opacity: page.is_active ? 1 : 0.5, // Reduce opacity when disabled
                                        }}
                                        onClick={page.is_active ? () => handleRescanPage(page) : null}
                                        title={page.is_active ? "Re-Scan Page" : ""}
                                      />
                                    </div>
                                    )}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td style={styles.noRecordCell} colSpan="4">No files available!</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </React.Fragment>
                ))
              ) : (
                <tr>
                  <td style={styles.noRecordCell} colSpan="4">No files available!</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const styles = {
  heroSection: {
    backgroundColor: "#f9f9f9",
    borderRadius: "8px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    padding: "20px",
  },
  heroTitle: {
    fontWeight: "bold",
    color: "#333",
  },
  heroText: {
    color: "#555",
    fontSize: "1rem",
    marginBottom: "1rem",
  },
  headerCell: {
    border: "1px solid #ddd",
    padding: "8px",
    textAlign: "left",
    fontWeight: "bold",
  },
  cell: {
    border: "1px solid #ddd",
    padding: "8px",
    textAlign: "left",
  },
  row: {
    // backgroundColor: "#fff",
    ':hover': { backgroundColor: '#f9f9f9' },
  },
  noRecordCell: {
    padding: "10px",
    textAlign: "left",
    color: "#888",
    border: "1px solid #ddd",
  },

  closeButton: {
    top: '10px',
    right: '15px',
    background: 'none',
    border: 'none',
    fontSize: '30px',
    color: '#333',
  },

  popupContent: {
    backgroundColor: 'white',
    padding: '0px 20px 20px 20px',
    borderRadius: '5px'
  },

  deletePopupContent: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '5px'
  },

  rescanPopupContent: {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '5px'
  },

  popup: {
    position: 'fixed',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },

  validationMessage: {
    fontSize: '14px',
    color: 'red'
  },

  deleteButton: {
    marginRight: '10px',
  },
  cancelButton: {
    marginLeft: '10px',
  },
  rescanButton: {
    marginRight: '10px',
  },
  inputField: {
    width: '100%'
  }
};

export default ScanWebsite;
